export enum Color {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  GRID_PRIMARY = 'gridPrimary',
  GRID_SECONDARY = 'gridSecondary',
  TRANSPARENT = 'transparent',
}
